<template>
  <j-editable-table ref="editableTable"
                    :loading="loading"
                    :columns="columns"
                    :dataSource="dataSource"
                    :rowNumber="true"
                    :maxHeight="340"
                    @valueChange="handleChange"
                    :disabledRows="{ dbFieldName:'id'}" />
</template>

<script>

import { FormTypes } from '@/utils/JEditableTableUtil'

import { syncAllTable } from '../util/TableUtils'

const pageQueryOptions = [
  { title: '文本框', value: 'text' },
  { title: '日期(yyyy-MM-dd)', value: 'date' },
  { title: '日期（yyyy-MM-dd HH:mm:ss）', value: 'datetime' },
  { title: '时间（HH:mm:ss）', value: 'time' },
  { title: '下拉框', value: 'list' },
  { title: '下拉多选框', value: 'list_multi' },
  { title: '下拉搜索框', value: 'sel_search' },
  { title: '分类字典树', value: 'cat_tree' },
  { title: 'Popup弹框', value: 'popup' },
  { title: '部门选择', value: 'sel_depart' },
  { title: '用户选择', value: 'sel_user' },
  { title: '省市区组件', value: 'pca' },
  { title: '自定义树控件', value: 'sel_tree' },
]

export default {
  name: 'QueryTable',
  components: {},
  data() {
    return {
      loading: false,
      dataSource: [],
      columns: [
        {
          title: 'tableHeader.fieldName', // 只读
          language_key: 'tableHeader.fieldName', // 只读
          key: 'dbFieldName',
          // width: '12%',
          width: '200px',
          type: FormTypes.input,
          defaultValue: '',
          placeholder: '',
          props: { 'disabled': true }
        },
        {
          title: 'tableHeader.fieldRemark', // 只读
          language_key: 'tableHeader.fieldRemark', // 只读
          key: 'dbFieldTxt',
          // width: '12%',
          width: '200px',
          type: FormTypes.input,
          defaultValue: '',
          placeholder: '',
          props: { 'disabled': true }
        },
        {
          title: 'tableHeader.controlType',
          language_key: 'tableHeader.controlType',
          key: 'queryShowType',
          // width: '16%',
          width: '200px',
          type: FormTypes.select,
          options: pageQueryOptions,
          defaultValue: 'text',
          placeholder: this.$t('tip.pleaseSelect') + '${language_key}',
        },
        {
          title: 'tableHeader.fieldDic',
          language_key: 'tableHeader.fieldDic',
          key: 'queryDictTable',
          // width: '12%',
          width: '180px',
          type: FormTypes.input_pop,
          defaultValue: ''
        },
        {
          title: 'tableHeader.fieldDicCode',
          language_key: 'tableHeader.fieldDicCode',
          key: 'queryDictField',
          // width: '12%',
          width: '150px',
          type: FormTypes.input,
          defaultValue: ''
        },
        {
          title: 'tableHeader.fieldDicCodeText',
          language_key: 'tableHeader.fieldDicCodeText',
          key: 'queryDictText',
          // width: '12%',
          width: '150px',
          type: FormTypes.input,
          defaultValue: ''
        },
        {
          title: 'tableHeader.defaultValue',
          language_key: 'tableHeader.defaultValue',
          key: 'queryDefVal',
          // width: '12%',
          width: '150px',
          type: FormTypes.input,
          defaultValue: ''
        },
        {
          title: 'tableHeader.enabledOrNot',
          language_key: 'tableHeader.enabledOrNot',
          key: 'queryConfigFlag',
          // width: '7%',
          width: '150px',
          type: FormTypes.checkbox,
          customValue: ['1', '0'],
          defaultChecked: false
        }
      ]
    }
  },
  computed: {

  },
  methods: {
    /** 同步列表 */
    async syncTable(table1) {
      await syncAllTable(this, table1)
    },
    handleChange({ row, column, value }) {
      if (column.key === 'queryConfigFlag') {
        if (value === true) {
          this.$emit('query', row.id)
        }
      }
    }
  }
}
</script>